export const AUTOCOMPLETE_DEBOUNCE_TIME: number = 200;
export const AUTOCOMPLETE_MINIMAL_CHARACTERS: number = 3;
